import type {CopilotChatModel} from '@github-ui/copilot-chat-types'
import {SyncIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'

import {ModelPicker} from './ModelPicker'

export interface RetryButtonProps {
  handleRetryMessage: (model?: CopilotChatModel) => void
  disabled?: boolean
  showModelPicker?: boolean
  model?: CopilotChatModel
  navigateToNewThread?: () => Promise<void>
}

export function RetryButton({
  handleRetryMessage,
  disabled = false,
  showModelPicker = false,
  model,
  navigateToNewThread,
}: RetryButtonProps) {
  const handleClick = () => {
    handleRetryMessage(model)
  }

  if (showModelPicker && (!navigateToNewThread || !model)) {
    throw new Error('navigateToNewThread and model must be provided in order to show the model picker')
  }

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const newThreadHandler = navigateToNewThread!

  return showModelPicker ? (
    <ModelPicker
      onNewThreadSelected={newThreadHandler}
      type={'message-retry'}
      selectedModel={model}
      onModelSelected={handleRetryMessage}
      disabled={disabled}
    />
  ) : (
    <IconButton
      variant="invisible"
      aria-label="Retry"
      data-testid="retry-button"
      onClick={handleClick}
      icon={SyncIcon}
      disabled={disabled}
    />
  )
}
